import { HttpResponse, delay, http } from 'msw';

import { getCustomHandlerLoginStatus } from './utils';
import { MOCK_DELAY } from './utils/constants';

export const getCustomPlatformGetSyncRunStatsMockHandler = () => {
  return http.get('*/teams/:team/syncs/:sync_name/runs/:sync_run_id/stats', async () => {
    await delay(MOCK_DELAY);

    if (!getCustomHandlerLoginStatus()) {
      return new HttpResponse(null, { status: 401 });
    }

    const items = {
      completed_tables: 93,
      errors: 5,
      last_completed_at: '2024-06-17T16:22:16.715026Z',
      panics: 0,
      resources: 2000,
      started_at: '2024-06-17T14:09:04.884907Z',
    };

    return HttpResponse.json(items, {
      status: 200,
    });
  });
};
